/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function n(n){if(null==n)return[];const r=new Array(n.length);for(let t=0;t<n.length;t++)r[t]=n.charCodeAt(t);return r}export{n as codepoints};
